import { Move, Video, Syllabus } from "../types";
import * as fetch from "../common/Services/fetch";
import ResourceService from "../common/Services/ResourceService";

class MoveService extends ResourceService<Move> {
  constructor() {
    super({
      path: "/moves",
      queryKey: "moves",
    });
  }

  static listMoves() {
    return new MoveService().list();
  }

  static fetchMove(id: Move["id"]) {
    return new MoveService().fetch({ id });
  }

  static createMove(
    payload: Partial<Move> & {
      videos?: Video["id"][];
      syllabus?: Syllabus["id"];
    }
  ) {
    return new MoveService().create(payload);
  }

  static updateMove(
    id: Move["id"],
    payload: Partial<Move> & {
      videos?: Video["id"][];
      syllabus?: Syllabus["id"];
    }
  ) {
    return new MoveService().update({ ...payload, id });
  }

  static listMoveVideos(id: Move["id"]) {
    return new MoveService().listVideos({ id });
  }

  static updateMoveToAddVideo(id: Move["id"], videoId: Video["id"]) {
    return new MoveService().addVideo({ id, videoId });
  }

  static updateMoveToRemoveVideo(id: Move["id"], videoId: Video["id"]) {
    return new MoveService().removeVideo({ id, videoId });
  }

  static deleteMove(id: Move["id"]): Promise<void> {
    return new MoveService().deleteOne({ id });
  }

  listVideos({ id }: Pick<Move, "id">): Promise<Video[]> {
    return fetch.get(`${this.path}/${id}/videos`);
  }

  addVideo({
    id,
    videoId,
  }: {
    id: Move["id"];
    videoId: Video["id"];
  }): Promise<Move> {
    return this.post([id, "videos", videoId]);
  }

  removeVideo({
    id,
    videoId,
  }: {
    id: Move["id"];
    videoId: Video["id"];
  }): Promise<Move> {
    return this.delete([id, "videos", videoId]);
  }
}

export default MoveService;
